export const BUTTON_ICON_ICON_SIZE = {
  small: 16,
  medium: 24,
  large: 32
} as const;

export const BUTTON_ICON_CLASS_SIZE = {
  small: 4,
  medium: 6,
  large: 8
} as const;
